export default "__VITE_ASSET__7c461e9e__"